const isDashboard = (url) => /:\/\/[^./]*dashboard(-templates)?\./
  .test(url);

// eslint-disable-next-line unicorn/prefer-module
module.exports = isDashboard;
